import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './paid.module.scss';
import ButtonSimple from '../HeroBlockBlog/components/ButtonSimple/ButtonSimple';
import FooterButton from '../Footer/components/FooterButton/FooterButton';

export type PaidType = {
  className?: string;
};

const Paid: NextPage<PaidType> = ({ className = '' }) => {
  return (
    <section className={styles.paid}>
      <div className="container">
        <div className={[styles.paid1440px, className].join(' ')}>
          <section className={styles.block}>
            <Image
              className={styles.logoIcon}
              loading="lazy"
              width={136}
              height={108}
              sizes="100vw"
              alt=""
              src="/img/modal/success-logo.webp"
            />
            <div className={styles.text}>
              <div className={styles.name}>
                Your flight has been successfully paid for.
              </div>
              <h3 className={styles.name1}>
                We sincerely thank you for choosing Hera Flight!
              </h3>
            </div>
          </section>
          <div className={styles.buttongroup}>
            <ButtonSimple
              className={styles.submitButton}
              color="accent"
              highContrast
              loading={false}
              size={3}
              state="default ✦"
              variant="solid ✦"
              text="Go to Homepage"
              iconStart={false}
              iconEnd={false}
              focusRing={false}
              designBlendingMode="/design--blendingmode1.svg"
              designBlendingMode1="/design--blendingmode1.svg"
              href="/"
            />
            <FooterButton
              className={styles.footerButton}
              color="accent"
              highContrast={false}
              loading={false}
              size={3}
              state="default ✦"
              variant="solid ✦"
              text="Contact Us"
              iconStart={false}
              iconEnd={false}
              focusRing={false}
              border1={true}
              href="/contact/"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Paid;
